import React from 'react';

import './Social.scss';

import Facebook from '../Assets/facebook';
import Instagram from '../Assets/instagram';
import Tiktok from '../Assets/tiktok';

function Social({ color, header }) {
  return (
    <div className='banzai_social_icon'>
      <a 
        target='_blank' 
        rel="noreferrer" 
        href='https://www.instagram.com/nudolsbanzai/' 
        aria-label='Instagram'
      >
        <Instagram color={color ? color : 'white'} width={ header && 30 } />
      </a>
      <a 
        target='_blank' 
        rel="noreferrer" 
        href='https://www.facebook.com/profile.php?id=61562170201548' 
        aria-label='Facebook'
      >
        <Facebook color={color ? color : 'white'} width={ header && 30 } />
      </a>
      <a 
        target='_blank' 
        rel="noreferrer" 
        href='https://www.tiktok.com/@nudolsbanzai?_t=8nqWymiGU1g&_r=1' 
        aria-label='Tiktok'
      >
        <Tiktok color={color ? color : 'white'} width={ header && 30 } />
      </a>
    </div>
  );
}

export default Social;
